module.exports = __webpack_public_path__ + "static/img/bullish.90f2627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bullish.png
// module id = vm9q
// module chunks = 1